


































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator"
import defaultRecords from "./defaultRecords";
import { mapGetters } from "vuex";
import SubsidiaryLedgerVue from "@/views/SubsidiaryLedger.vue";
import NumCurrencySubsidiaryVue from "@/components/SubsidiaryLedger/NumCurrencySubsidiary.vue";
import SubjectAssistVue from "@/components/SubsidiaryLedger/SubjectAssist.vue";

@Component({
    ...mapGetters(["account", "accountBook"]),
    components: {
        "subsisiary-dialog": SubsidiaryLedgerVue,
        "num-currency-subsidiary": NumCurrencySubsidiaryVue,
		"subject-assist": SubjectAssistVue,
    },
})
export default class voucherRecord extends Vue {
    @Prop({ type: Array })
    rows: any;

    @Prop({ type: Number })
    rowIndex: any;

    @Prop({ type: Array })
    subjectList: any;

    @Prop({ type: Boolean })
    hasForeign: any;

    @Prop({ type: Boolean })
    isCate: any;

    assistList: any = [];
    showAssist: boolean = false;
    showSubjectText: boolean = true;
    tempSubject: any = {};
    assist: any = null;
    showSymbol: boolean = false;
    showNum: boolean = false;
    showSymNum: boolean = false;
    orgTemp: number = 0;
    exchangeRateTemp: number = 0;
    numberTemp: number = 0;
    unitPriceTemp: number = 0;
    showJf: boolean = false;
    showDf: boolean = false;
    jfmoney: any = new Array(11);
    dfmoney: any = new Array(11);
    jfTemp: number | string = 0;
    dfTemp: number | string = 0;
    showAddSub: boolean = false;
    showAddAssist: boolean = false;
    tmpAss: any = null;
    tmpOld: any = {};
    noChange: boolean = false;
    _uid: number = 0;

    @Watch("showAssist")
    showAssistChange(val: any) {
        if (!val) {
            this.canScroll()
        } else {
            this.$nextTick(() => {
                let diaEx = (<any>this.$parent).isDialog ? 24 : 0,
                    bound = document.querySelectorAll(".voucherRow")[this.rowIndex].getBoundingClientRect().top - 240 + diaEx,
                    assModal: any = this.$el.querySelector("#assModal");
                assModal.style.top = -bound + "px";
                let assist: any = document.querySelector(".assistModal"),
                    top = bound + 60 + 125 > 300 ? bound - 125 : bound + 60;
                assist.style.top = top + "px";
            });
        }
    }

    @Watch("showNum")
    showNumChange(val: any) {
        if (val) {
            this.forbidScroll();
            this.numberTemp = this.rows[this.rowIndex].number;
            this.unitPriceTemp = this.rows[this.rowIndex].unitPrice;
        } else {
            this.canScroll()
        }
    }

    @Watch("showSymbol")
    showSymbolChange(val: any) {
        if (val) {
            this.forbidScroll();
            this.orgTemp = this.rows[this.rowIndex].org;
            this.exchangeRateTemp = this.rows[this.rowIndex].exchangeRate;
        } else {
            this.canScroll()
        }
    }

    @Watch("showSymNum")
    showSymNumChange(val: any) {
        if (val) {
            this.forbidScroll();
            this.numberTemp = this.rows[this.rowIndex].number;
            this.unitPriceTemp = this.rows[this.rowIndex].unitPrice;
            this.orgTemp = this.rows[this.rowIndex].org;
            this.exchangeRateTemp = this.rows[this.rowIndex].exchangeRate;
        } else {
            this.canScroll()
        }
    }

    @Watch("tempSubject")
    tempSubjectChange(val: any, old: any) {
        if (val.balance) {
            if (!this.noChange) this.rows[this.rowIndex].foresubText = this.rows[this.rowIndex].subject.no + " " + this.rows[this.rowIndex].subject.longText;
            let balance = +this.rows[this.rowIndex].subject.balance.endbalance;
            // 有金额时切换科目,科目余额 扣除 当前行的金额 计算
            if (this.rows[this.rowIndex].jfmoney != "") {
                // alert("jf")
                if (val.direction == 1) {
                    // this.rows[this.rowIndex].subject.balance.endbalance = balance + +this.rows[this.rowIndex].jfmoney;
                    if (old.balance) {
                        this.subjectList[this.subjectList.indexOf(old)].balance.endbalance = +this.subjectList[this.subjectList.indexOf(old)].balance.endbalance - +this.rows[this.rowIndex].jfmoney;
                    }
                } else {
                    this.rows[this.rowIndex].subject.balance.endbalance = balance - +this.rows[this.rowIndex].jfmoney;
                    if (old.balance) {
                        this.subjectList[this.subjectList.indexOf(old)].balance.endbalance = +this.subjectList[this.subjectList.indexOf(old)].balance.endbalance + +this.rows[this.rowIndex].jfmoney;
                    }
                }
            } else if (this.rows[this.rowIndex].dfmoney != "") {
                if (val.direction == 1) {
                    this.rows[this.rowIndex].subject.balance.endbalance = balance - +this.rows[this.rowIndex].dfmoney;
                    if (old.balance) {
                        this.subjectList[this.subjectList.indexOf(old)].balance.endbalance = +this.subjectList[this.subjectList.indexOf(old)].balance.endbalance + +this.rows[this.rowIndex].dfmoney;
                    }
                } else {
                    this.rows[this.rowIndex].subject.balance.endbalance = balance + +this.rows[this.rowIndex].dfmoney;
                    if (old.balance) {
                        this.subjectList[this.subjectList.indexOf(old)].balance.endbalance = +this.subjectList[this.subjectList.indexOf(old)].balance.endbalance - +this.rows[this.rowIndex].dfmoney;
                    }
                }
            }
        } else {
            if (old.balance) {
                if (old.direction == 1) {
                    if (this.jfTemp != 0) {
                        old.balance.endbalance -= +this.jfTemp;
                        old.balance.assist[this.tmpAss] -= +this.jfTemp;
                        this.jfTemp = 0;
                    } else if (this.dfTemp != 0) {
                        old.balance.endbalance += +this.dfTemp;
                        old.balance.assist[this.tmpAss] += +this.dfTemp;
                        this.dfTemp = 0;
                    }
                } else {
                    if (this.jfTemp != 0) {
                        old.balance.endbalance += +this.jfTemp;
                        old.balance.assist[this.tmpAss] += +this.jfTemp;
                        this.jfTemp = 0;
                    } else if (this.dfTemp != 0) {
                        old.balance.endbalance -= +this.dfTemp;
                        old.balance.assist[this.tmpAss] -= +this.dfTemp;
                        this.dfTemp = 0;
                    }
                }
            }
        }
    }

    @Watch("showSubjectText")
    showSubjectTextChange(val: any) {
        if (!val) {
            this.showAddSub = true;
            this.$nextTick(() => {
                let sub: any = document.querySelector(".voucherSubjectSelect input");
                sub.focus();
            })
        } else {
            setTimeout(() => { this.showAddSub = false }, 50)
        }
    }

    @Watch("showJf")
    showJfChange(val: any) {
        if (val) {
            this.showDf = false;
            this.$nextTick(() => {
                if (!this.isCate) {
                    let jf: any = document.querySelectorAll(".voucherLoan");
                    if (jf[this.rowIndex].querySelector("input") != null) jf[this.rowIndex].querySelector("input").focus()
                } else {
                    (<any>document.querySelectorAll(".voucherRow")[this.rowIndex + 1].querySelector(".rowSummary textarea")).focus();
                }
            })
        }
    }

    @Watch("showDf")
    showDfChange(val: any) {
        if (val) {
            this.showJf = false;
            this.$nextTick(() => {
                let df: any = document.querySelectorAll(".voucherCredit");
                df[this.rowIndex].querySelector("input").focus()
            })
        }
    }

    jfChange(val?: any, notChange?: any, noChangeDf?: boolean) {
        // if(this.rows.length <= 50) this.jfTemp = val;
        if (!notChange) {
            if (this.rows[this.rowIndex].currSymbol != null && this.rows[this.rowIndex].org != 0)
                this.rows[this.rowIndex].exchangeRate = Math.abs((Math.abs(+val) / +this.rows[this.rowIndex].org)).toFixed(5)
            if (this.rows[this.rowIndex].measuringUnit != null && this.rows[this.rowIndex].number != 0)
                this.rows[this.rowIndex].unitPrice = Math.abs((Math.abs(+val) / +this.rows[this.rowIndex].number)).toFixed(4)
            this.$emit("addJf", val)
        }
        if (val != 0 && val != "") {
            this.rows[this.rowIndex].dfmoney = "";
            if (!noChangeDf) this.dfTemp = 0;
            if (!noChangeDf) this.dfChange("", true);
            if (!noChangeDf) this.dfBlur("dfmoney", true);
        }
    }
    dfChange(val?: any, notChange?: any, noChangeJf?: boolean) {
        // if(this.rows.length <= 50) this.dfTemp = val;
        if (!notChange) {
            if (this.rows[this.rowIndex].currSymbol != null && this.rows[this.rowIndex].org != 0)
                this.rows[this.rowIndex].exchangeRate = (Math.abs(+val) / +this.rows[this.rowIndex].org).toFixed(5)
            if (this.rows[this.rowIndex].measuringUnit != null && this.rows[this.rowIndex].number != 0)
                this.rows[this.rowIndex].unitPrice = Math.abs(+val / +this.rows[this.rowIndex].number).toFixed(4)
            this.$emit("addDf", val)
        }
        if (val != 0 && val != "") {
            this.rows[this.rowIndex].jfmoney = "";
            if (!noChangeJf) this.jfTemp = 0
            if (!noChangeJf) this.jfChange("", true)
            if (!noChangeJf) this.jfBlur("dfmoney", true)
        }
    }

    findSubject(id: number) {
        for (let i = 0; i < this.subjectList.length; i++) {
            const subject = this.subjectList[i];
            if (subject.id === id) return i;
        }
        return -1;
    }
    setBalance() {
        const si = this.findSubject(this.rows[this.rowIndex].subject.id);
        if (!this.subjectList[si].balance.assist) {
            this.subjectList[si].balance.assist = {};
        }
        if (!this.subjectList[si].balance.assist.endnumber) {
            this.subjectList[si].balance.assist = {
                endnumber: {
                    [this.rows[this.rowIndex].assistantAccountId]: this.rows[this.rowIndex].endnumber
                },
                [this.rows[this.rowIndex].assistantAccountId]: this.rows[this.rowIndex].endbalance
            }
        } else {
            if (!this.subjectList[si].balance.assist[this.rows[this.rowIndex].assistantAccountId]) {
                this.subjectList[si].balance.assist[this.rows[this.rowIndex].assistantAccountId] = this.rows[this.rowIndex].endbalance;
                this.subjectList[si].balance.assist.endnumber[this.rows[this.rowIndex].assistantAccountId] = this.rows[this.rowIndex].endnumber;
            }

        }
    }
    @Watch("jfTemp", { immediate: true, deep: true })
    jfTempChange(val: any, old: any, set: any) {
        let parent: any = this.$parent;
        if (JSON.stringify(this.rows[this.rowIndex].subject) != "{}" && !this.noChange && !parent.noBalance) {
            let origin, direction = this.rows[this.rowIndex].subject.direction;
            !old || old == "" ? origin = 0 : origin = +old;
            const num = this.rows[this.rowIndex].number;
            const numberOrg = old == "" ? 0 : +num;

            this.setBalance();
            const si = this.findSubject(this.rows[this.rowIndex].subject.id);
            let attribute = this.rows[this.rowIndex].assistantAccountId == null ? this.rows[this.rowIndex].subject.balance.endnumber : this.subjectList[si].balance.assist.endnumber[this.rows[this.rowIndex].assistantAccountId];
            if (direction == 1) {
                if (this.rows[this.rowIndex].assistantAccountId == null) {
                    this.rows[this.rowIndex].subject.balance.endbalance = (+this.rows[this.rowIndex].subject.balance.endbalance + +val - origin).toFixed(2);
                } else {
                    this.subjectList[si].balance.assist[this.rows[this.rowIndex].assistantAccountId] = (Number(this.rows[this.rowIndex].subject.balance.assist[this.rows[this.rowIndex].assistantAccountId]) + +val - origin).toFixed(2)
                }
                if (this.rows[this.rowIndex].measuringUnit !== null) {
                    if (val !== "") {
                        attribute = (+attribute + +num - numberOrg).toFixed(2);
                        if (+this.numberTemp !== +num) {
                            attribute = (+attribute - +this.numberTemp).toFixed(2);
                            this.numberTemp = num;
                        }
                    } else if (old !== 0 && old !== "") {
                        attribute = (+attribute - +num).toFixed(2);
                    }
                }
            } else {
                if (this.rows[this.rowIndex].assistantAccountId == null) {
                    this.rows[this.rowIndex].subject.balance.endbalance = (Number(this.rows[this.rowIndex].subject.balance.endbalance) - +val + origin).toFixed(2)
                } else {
                    this.subjectList[si].balance.assist[this.rows[this.rowIndex].assistantAccountId] = (Number(this.rows[this.rowIndex].subject.balance.assist[this.rows[this.rowIndex].assistantAccountId]) - +val + origin).toFixed(2)
                }
                if (this.rows[this.rowIndex].measuringUnit !== null) {
                    if (val !== "") {
                        attribute = (+attribute - +num + numberOrg).toFixed(2);
                        if (+this.numberTemp !== +num) {
                            attribute = (+attribute + +this.numberTemp).toFixed(2);
                            this.numberTemp = num;
                        }
                    } else if (old !== 0 && old !== "") {
                        attribute = (+attribute + +num).toFixed(2);
                    }
                }
            }
            if (this.rows[this.rowIndex].assistantAccountId == null) {
                this.rows[this.rowIndex].subject.balance.endnumber = attribute;
            } else {
                this.subjectList[si].balance.assist.endnumber[this.rows[this.rowIndex].assistantAccountId] = attribute;
            }
        }
        if (set) this.jfTemp = set;
    }

    @Watch("dfTemp", { immediate: true, deep: true })
    dfTempChange(val: any, old: any, set: any) {
        let parent: any = this.$parent;
        if (JSON.stringify(this.rows[this.rowIndex].subject) != "{}" && !this.noChange && !parent.noBalance) {
            let origin, direction = this.rows[this.rowIndex].subject.direction;
            !old || old == "" ? origin = 0 : origin = +old;
            const num = this.rows[this.rowIndex].number;
            const numberOrg = old == "" ? 0 : +num;
            
            const si = this.findSubject(this.rows[this.rowIndex].subject.id);
            this.setBalance();
            let attribute = this.rows[this.rowIndex].assistantAccountId == null ? this.rows[this.rowIndex].subject.balance.endnumber : this.subjectList[si].balance.assist.endnumber[this.rows[this.rowIndex].assistantAccountId];
            if (direction == 1) {
                if (this.rows[this.rowIndex].assistantAccountId == null) {
                    this.rows[this.rowIndex].subject.balance.endbalance = (+this.rows[this.rowIndex].subject.balance.endbalance - +val + origin).toFixed(2);
                } else {
                    this.rows[this.rowIndex].subject.balance.assist[this.rows[this.rowIndex].assistantAccountId] = (+(this.rows[this.rowIndex].subject.balance.assist[this.rows[this.rowIndex].assistantAccountId]) - +val + origin).toFixed(2);
                }
                if (this.rows[this.rowIndex].measuringUnit !== null) {
                    if (val !== "") {
                        attribute = (+attribute - +this.rows[this.rowIndex].number + numberOrg).toFixed(2);
                        if (+this.numberTemp !== +this.rows[this.rowIndex].number) {
                            attribute = (+attribute + +this.numberTemp).toFixed(2);
                            this.numberTemp = this.rows[this.rowIndex].number;
                        }
                    } else if (old !== 0 && old !== "") {
                        attribute = (+attribute + +this.rows[this.rowIndex].number).toFixed(2);
                    }
                }
            } else {
                if (this.rows[this.rowIndex].assistantAccountId == null) {
                    this.rows[this.rowIndex].subject.balance.endbalance = (+(this.rows[this.rowIndex].subject.balance.endbalance) + +val - origin).toFixed(2);
                } else {
                    this.rows[this.rowIndex].subject.balance.assist[this.rows[this.rowIndex].assistantAccountId] = (+(this.rows[this.rowIndex].subject.balance.assist[this.rows[this.rowIndex].assistantAccountId]) + +val - origin).toFixed(2);
                }
                if (this.rows[this.rowIndex].measuringUnit !== null) {
                    if (val !== "") {
                        attribute = (+attribute + +this.rows[this.rowIndex].number - numberOrg).toFixed(2);
                        if (+this.numberTemp !== +this.rows[this.rowIndex].number) {
                            attribute = (+attribute - +this.numberTemp).toFixed(2);
                            this.numberTemp = this.rows[this.rowIndex].number;
                        }
                    } else if (old !== 0 && old !== "") {
                        attribute = (+attribute - +this.rows[this.rowIndex].number).toFixed(2);
                    }
                }
            }
            if (this.rows[this.rowIndex].assistantAccountId == null) {
                this.rows[this.rowIndex].subject.balance.endnumber = attribute;
            } else {
                this.subjectList[si].balance.assist.endnumber[this.rows[this.rowIndex].assistantAccountId] = attribute;
            }
        }
        if (set) this.dfTemp = set;
    }

    subTime: any = [];
    subId: any = null;
    isSub: boolean = false;
    subRelation: any = null;
    async showSubsiliary(val: any) {
        this.subTime = [(<any>this.$parent).dateTime, (<any>this.$parent).dateTime];
        this.subId = val;
        this.subRelation = val.relation;
        if (!this.rows[this.rowIndex].relation) this.rows[this.rowIndex].relation = val.relation;
        const rel = this.rows[this.rowIndex].relation;

        if (rel && JSON.stringify(rel) !== "{}") {
            await this.fetchAssist();
            this.assistBalance.visible = true;
        } else if (val.measuringUnit === null && val.currSymbol === null ) {
            this.isSub = true;
        } else {
            this.assistBalance.visible = false;
            await this.fetchAssist();
            this.assistBalance.numVisible = true;
        }

    }

    // 快捷键
    toSubject(e: any) {
        e.preventDefault();
        this.showSubjectText = false;
        (<any>this.$parent).tmpId = this._uid;
    }
    toJf(e: any) {
        e.preventDefault();
        // this.dfBlur();
        this.$nextTick(() => {
            // if (this.tempSubject.dimAccountType == null && this.tempSubject.currSymbol == null && this.tempSubject.measuringUnit == null) {
            //     this.showJf = true;
            //     // (<any>this.$refs).select.doDestroy();
            //     this.$nextTick(() => {
            //         this.showSubjectText = true;
            //     })
            // }
            this.showJf = true;
            this.$nextTick(() => {
                this.showSubjectText = true;
            })
        })
    }
    toDf(e: any) {
        e.preventDefault()
        this.jfBlur();
        this.$nextTick(() => {
            this.showDf = true
        })
    }
    toNextRow(e: any) {
        e.preventDefault();
        this.$emit("toNextRow", this.rowIndex);
    }
    returnNumber(e: any, inputFn: any, type: any) {
        if (e.keyCode != 187 && e.code != "Equal") {
            if (!(e.keyCode == 46) && !(e.keyCode == 8) && !(e.keyCode == 37) && !(e.keyCode == 39) && !(e.keyCode == 67) && !(e.keyCode == 86) && e.keyCode == 47) {
                if (!((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105))) {
                    if (e.keyCode != 13 && e.keyCode != 190 && e.keyCode != 187 && e.keyCode != 32 && e.keyCode != 110 && e.keyCode != 109 && e.keyCode != 189 && e.keyCode != 9) {
                        e.returnValue = false;
                    }
                } else {
                    inputFn()
                }
            }
        } else {
            e.returnValue = false;
            e.preventDefault();
            this.$nextTick(() => {
                if (type == 0) {
                    this.rows[this.rowIndex].jfmoney = 0;
                    this.jfChange(0);
                    let parent: any = this.$parent;
                    let cash = +parent.creditTotal - +parent.loanTotal + +this.rows[this.rowIndex].jfmoney - +this.rows[this.rowIndex].dfmoney;
                    this.rows[this.rowIndex].jfmoney = cash;
                    this.jfChange(cash)
                } else {
                    this.rows[this.rowIndex].dfmoney = 0;
                    this.dfChange(0);
                    let parent: any = this.$parent;
                    let cash = +parent.loanTotal - +parent.creditTotal + +this.rows[this.rowIndex].dfmoney - +this.rows[this.rowIndex].jfmoney;
                    this.rows[this.rowIndex].dfmoney = cash;
                    this.dfChange(cash)
                }
            })
        }
    }
    cleanDf(e: any, type: any) {
        this.returnNumber(e, () => {
            this.rows[this.rowIndex].dfmoney = "";
            this.dfChange("", true)
            this.dfBlur("dfmoney", true)
        }, type)
    }
    cleanJf(e: any, type: any) {
        this.returnNumber(e, () => {
            this.rows[this.rowIndex].jfmoney = "";
            this.jfChange("", true)
            this.jfBlur("jfmoney", true)
        }, type)
    }
    pressSpace(e: any, val: any, isJf?: boolean) {
        e.preventDefault();
        let _this: any = this;
        let tmp = JSON.parse(JSON.stringify(this.rows[this.rowIndex].dfmoney));
        this.rows[this.rowIndex].dfmoney = this.rows[this.rowIndex].jfmoney;
        this.rows[this.rowIndex].jfmoney = tmp;
        _this[val] = true;
        // Vue.set(this, val, true);

        this.$nextTick(() => {
            if (isJf) {
                // this.jfChange(0);
                this.dfChange(this.rows[this.rowIndex].dfmoney);
                if (this.rows[this.rowIndex].jfmoney !== 0 && this.rows[this.rowIndex].jfmoney !== "") this.jfChange(this.rows[this.rowIndex].jfmoney);
                else this.toDf(e);
            } else {
                this.jfChange(this.rows[this.rowIndex].jfmoney);
                if (this.rows[this.rowIndex].dfmoney !== 0 && this.rows[this.rowIndex].dfmoney !== "") this.dfChange(this.rows[this.rowIndex].dfmoney);
                else this.toJf(e);
            }
        });
    }

    //显示隐藏btns
    showBtn(e: any) {
        let allBtn: any = document.querySelectorAll(".rowBtn");
        allBtn.forEach((v: any, i: any, a: any) => {
            v.style.display = "none"
        })
        let rowBtn: any = this.$el.querySelectorAll(".rowBtn");
        rowBtn[0].style.display = "block"
        rowBtn[1].style.display = "block"
    }

    //增加行
    addRow() {
        let one = new defaultRecords().one;
        this.$emit("addRow", this.rowIndex, one)
    }
    deleteRow() {
        // 有金额时切换科目,科目余额 扣除 当前行的金额 计算
        this.changeSubject({}, this.rows[this.rowIndex].subject)
        this.jfTemp = 0;
        this.dfTemp = 0;
        (<any>this.$parent).tmpId = this._uid;
        if (this.rows.length > 5) {
            // this.jfBlur(0, true);
            // this.dfBlur(0, true);
            this.$emit("delete", this.rowIndex)
        } else {
            let one = new defaultRecords().one;
            this.$nextTick(() => {
                this.jfBlur(0, true);
                this.dfBlur(0, true);
                this.$delete(this.rows, this.rowIndex);
                this.$emit("addRow", 4, one);
                this.jfBlur(0, true);
                this.dfBlur(0, true);
            })
        };
    }

    selectInner(e: any) {
        e.target.select()
    }

    forbidHandler(e: any) {
        e.returnValue = false;
    }
    canHandler(e: any) {
        e.returnValue = true;

    }
    // 锁定/释放 滚动条
    forbidScroll() {
        // let handler = (e: any) => {
        //     e.preventDefault();
        // },
        const tbody: any = document.querySelector(".voucherTbody");
        tbody.removeEventListener("mousewheel", this.canHandler)
        tbody.addEventListener("mousewheel", this.forbidHandler)
    }
    canScroll() {
        // let handler = (e: any) => {
        //     e.returnValue = true;
        // },
        const tbody: any = <HTMLElement>document.querySelector(".voucherTbody");
        tbody.removeEventListener("mousewheel", this.forbidHandler)
        tbody.addEventListener("mousewheel", this.canHandler)
    }

    /*
        处理此行的摘要
    */


    /*
        选择科目
        1.选择至普通科目,进入下个Input
        2.选择到辅助核算,结束后判断是否有数量外币
        3.选中无辅助核算,有数量外币
        4.点击subject div显示下拉框
    */
    //4.
    clickSubText(e: any) {
        let parent = (<any>this.$parent);
        if (!parent.notEdit) {
            parent.tmpId = this._uid;
            this.showSubjectText = false;
        }
    }

    //检查是否其他行有数量外币
    checkOther(type: any) {
        let attr;
        type == 1 ? attr = "measuringUnit" : attr = "currSymbol";
        for (var i = 0; i < this.rows.length; i++) {
            if (this.rows[i].subject[attr] != null) {
                // this.$parent.theadName = "数量/外币"
                // break
                return true
            } else {
                continue
            }
        }
        return false
    }

    toNextInput(e: any, then: any) {
        if (!then) {
            let modal: any = e.currentTarget.parentNode.parentNode,
                allInput: any = modal.querySelectorAll("input"),
                index: any = null;
            for (var i = 0; i < allInput.length; i++) {
                if (allInput[i] == e.target) index = i;
            }
            allInput[index + 1].focus()
        } else {
            then()
        }
    }

    // 自动移动模态框及背景
    moveModal(id: any) {
        this.$nextTick(() => {
            let row: any = document.querySelectorAll(".voucherRow")[this.rowIndex],
                voucherThead: any = document.querySelector("#voucherThead"),
                tHeadTop: any = voucherThead.getBoundingClientRect().top,
                outerTop: any = tHeadTop + 60,
                bound: any = row.getBoundingClientRect().top - outerTop;
            let eleID: any = document.querySelector("#" + id);
            eleID.style.top = -bound + "px";
            let sym: any = document.querySelector(".foreignModal"),
                top: any = 0;
            if (bound + 160 > 300) {
                top = bound - 100;
                sym.classList.add("bottomModal");
            } else if (bound < 0) {
                top -= bound
            } else {
                sym.classList.remove("bottomModal");
                top = bound;
            }
            if (id == "symNumModal") {
                if (bound + 218 > 300) {
                    top = bound - 160;
                    sym.classList.add("symBottom");
                } else if (bound <= 218 && bound >= 0) {
                    sym.classList.remove("symBottom");
                    top = bound;
                }

                if (bound < 218 && bound + 218 > 300) {
                    top = bound - 115
                    sym.classList.add("symCenter");
                } else if (bound < 0) {
                    top -= bound
                } else {
                    sym.classList.remove("symCenter");
                }
            }
            sym.style.top = top + "px"
            let ele: any = document.querySelector("#" + id);
            ele.querySelector("input").focus()
        })
    }

    //选择/改变科目
    changeSubject(val: any, old?: any) {
        let attribute = this.rows[this.rowIndex].subject && this.rows[this.rowIndex].subject.balance ? this.rows[this.rowIndex].subject.balance.endnumber : "";
        if (this.tmpAss != null) {
            attribute = this.subjectList[this.subjectList.indexOf(this.tmpOld)].balance.assist.endnumber[this.tmpAss];
            let oldAss = this.subjectList[this.subjectList.indexOf(this.tmpOld)].balance.assist[this.tmpAss];
            // 更换辅助核算后，除去当前行的金额计算，并对新选择的辅助核算进行计算
            if (this.tmpOld.direction == 1) {
                if (this.jfTemp != 0) {  // 有借方金额
                    this.subjectList[this.subjectList.indexOf(this.tmpOld)].balance.assist[this.tmpAss] = +oldAss - +this.jfTemp;
                } else if (this.dfTemp != 0) {
                    this.subjectList[this.subjectList.indexOf(this.tmpOld)].balance.assist[this.tmpAss] = +oldAss + +this.dfTemp;
                }
            } else {
                if (this.jfTemp != 0) {  // 有借方金额
                    this.subjectList[this.subjectList.indexOf(this.tmpOld)].balance.assist[this.tmpAss] = +oldAss + +this.jfTemp;
                } else if (this.dfTemp != 0) {
                    this.subjectList[this.subjectList.indexOf(this.tmpOld)].balance.assist[this.tmpAss] = +oldAss - +this.dfTemp;
                }
            }
        }
        if (this.rows[this.rowIndex].measuringUnit !== null && old) {
            if (old.direction == 1) {
                if (this.jfTemp != 0) {
                    attribute = +attribute - +this.rows[this.rowIndex].number;
                } else {
                    attribute = +attribute + +this.rows[this.rowIndex].number;
                }
            } else {
                if (this.jfTemp != 0) {
                    attribute = +attribute + +this.rows[this.rowIndex].number;
                } else {
                    attribute = +attribute - +this.rows[this.rowIndex].number;
                }
            }
        }

        if (this.tmpAss == null) {
            if (this.rows[this.rowIndex].subject && this.rows[this.rowIndex].subject.balance) this.rows[this.rowIndex].subject.balance.endnumber = attribute;
        } else {
            this.subjectList[this.subjectList.indexOf(this.tmpOld)].balance.assist.endnumber[this.tmpAss] = attribute;
        }
        this.rows[this.rowIndex].org = 0;
        this.rows[this.rowIndex].number = 0;
        this.rows[this.rowIndex].unitPrice = 0;
        this.rows[this.rowIndex].exchangeRate = 0;
        this.assist = null;
        this.rows[this.rowIndex].assist = null;
        this.tmpAss = null;
        this.getAssistAttr();
        this.rows[this.rowIndex].assistantAccountId = null;
        this.rows[this.rowIndex].subjectId = val.id;
        this.rows[this.rowIndex].relation = null;
        this.tempSubject = val;

        if (val.dimAccountType != null) {
            this.rows[this.rowIndex].currSymbol = val.currSymbol;
            this.rows[this.rowIndex].measuringUnit = val.measuringUnit;
            this.showAssSelect();
            if (val.currSymbol != null && val.measuringUnit == null) {
                if (this.checkOther(1)) (<any>this.$parent).theadName = "数量/外币"; else (<any>this.$parent).theadName = "外币";
            } else if (val.currSymbol == null && val.measuringUnit != null) {
                if (this.checkOther(2)) (<any>this.$parent).theadName = "数量/外币"; else (<any>this.$parent).theadName = "数量";
            } else if (val.currSymbol != null && val.measuringUnit != null) {
                (<any>this.$parent).theadName = "数量/外币";
            }
            // 模板状态不显示外币列
        } else if (val.currSymbol != null && val.measuringUnit == null && !(<any>this.$parent).isTp) {
            this.rows[this.rowIndex].currSymbol = val.currSymbol;
            this.rows[this.rowIndex].measuringUnit = val.measuringUnit;
            // this.showSymbol = true;
            if (this.checkOther(1)) (<any>this.$parent).theadName = "数量/外币"; else (<any>this.$parent).theadName = "外币";
            this.rows[this.rowIndex].exchangeRate = this.rows[this.rowIndex].subject.exchangeRate || 0;
            // this.moveModal("symModal")
            this.showForeignModal();
        } else if (val.currSymbol == null && val.measuringUnit != null && !(<any>this.$parent).isTp) {
            this.rows[this.rowIndex].currSymbol = val.currSymbol;
            this.rows[this.rowIndex].measuringUnit = val.measuringUnit;
            if (this.checkOther(2)) (<any>this.$parent).theadName = "数量/外币"; else (<any>this.$parent).theadName = "数量";
            // this.showNum = true;
            if (this.rows[this.rowIndex].subject.balance.unitPrice) this.rows[this.rowIndex].unitPrice = +(this.rows[this.rowIndex].subject.balance.unitPrice.replace(/,/g, "")) || 0;
            // this.moveModal("numModal")
            this.showForeignModal();
        } else if (val.currSymbol != null && val.measuringUnit != null && !(<any>this.$parent).isTp) {
            this.rows[this.rowIndex].currSymbol = val.currSymbol;
            this.rows[this.rowIndex].measuringUnit = val.measuringUnit;
            (<any>this.$parent).theadName = "数量/外币";
            // this.showSymNum = true;
            this.rows[this.rowIndex].exchangeRate = this.rows[this.rowIndex].subject.exchangeRate || 0;
            if (this.rows[this.rowIndex].subject.balance.unitPrice) this.rows[this.rowIndex].unitPrice = this.rows[this.rowIndex].subject.balance.unitPrice || 0;
            // this.moveModal("symNumModal")
            this.showForeignModal();
        } else {
            this.rows[this.rowIndex].currSymbol = val.currSymbol;
            this.rows[this.rowIndex].measuringUnit = val.measuringUnit;
            this.showJf = true
        }
    }

    leaveSubject(val: any) {
        // 选择科目结束后
        if (!val) {
            (<any>this.$refs).select.doDestroy()
            this.$nextTick(() => {
                this.showSubjectText = true;
            })
            if (this.rows[this.rowIndex].subject.dimAccountType != null) {
                this.showAssSelect();
            }
        }
    }

    getAssistAttr() {
        this.rows[this.rowIndex].assist = {};
        if (this.rows[this.rowIndex].subject.dimAccountTypes) {
            this.rows[this.rowIndex].subject.dimAccountTypes.forEach((v: any, i: number) => {
                this.rows[this.rowIndex].assist[i] = "";
            })
            this.$forceUpdate()
        }
    }

    //获取辅助核算项
    getAssistList(name: string, then?: any) {
        this.rows[this.rowIndex].assistList = {};
        let _this = this;
        Vue.axios.get("/dim/find?accountBookId=" + this.$store.state.accountBook.id + "&dimAccountType=" + name).then(response => {
            _this.rows[_this.rowIndex].assistList[name] = response.data;
            _this.$forceUpdate();
            if (then) then()
        })
    }

    //选择辅助核算
    changeAssist(val: any, end: boolean, i: number) {
        if (val.id) {
            if (val.measureUnit != null) this.rows[this.rowIndex].measuringUnit = val.measureUnit;
        }
        this.$forceUpdate();
        if (end) this.confirmAssist();
        else {
            let input: any = document.querySelectorAll(".assistMain")[i + 1].querySelector("input");
            this.$nextTick(() => {
                (<any>this.$refs[`dimistSelect-${i + 1}`])[0].focus();
            });
        }
    }

    cancelAssist() {
        // this.$refs.assistSelect.doDestroy()
        this.showAssist = false
    }

    transRelation(val: string) {
        switch (val) {
            case "项目": return "dimItemId";
            case "客户": return "dimCustomerId";
            case "部门": return "dimDepartmentId";
            case "员工": return "dimEmployeeId";
            case "存货": return "dimInventoryId";
            case "供应商": return "dimProviderId";
            default: return "dimItemId";
        }
    }

    get relation() {
        let obj: any = null;
        if (this.rows[this.rowIndex].assist != null && this.rows[this.rowIndex].subject.dimAccountTypes && JSON.stringify(this.rows[this.rowIndex].assist) != "{}") {
            obj = {};
            this.rows[this.rowIndex].subject.dimAccountTypes.forEach((v: any, i: number) => {
                let attr = this.transRelation(v);
                obj[attr] = this.rows[this.rowIndex].assist[v].id;
            })
        }
        this.rows[this.rowIndex].relation = obj;
        return obj;
    }

    //确认辅助核算
    async confirmAssist(noChangeDom?: any, noCalc?: boolean) {
        // mark
        if (this.rows[this.rowIndex].assist != null && this.rows[this.rowIndex].subject.dimAccountTypes) {
            let tmp = {
                id: this.rows[this.rowIndex].subject.id,
                relation: this.relation
            }
            const response = await Vue.axios.post("/subjects/one", tmp);
            if (!noChangeDom) {
                this.showForeignModal();
                // (<any>this.$refs).assistSelect.doDestroy()
                this.showAssist = false;
                let no = "",
                    name = "";
                Object.keys(this.rows[this.rowIndex].assist).forEach(v => {
                    if (this.rows[this.rowIndex].assist[v] != null && this.rows[this.rowIndex].assist[v].no) {
                        no += `.${this.rows[this.rowIndex].assist[v].no}`;
                        name += `.${this.rows[this.rowIndex].assist[v].name}`;
                    }
                })

                let curSubject = this.rows[this.rowIndex].foresubText,
                    curNo = this.rows[this.rowIndex].subject.no,
                    curName = this.rows[this.rowIndex].subject.longText;
                this.rows[this.rowIndex].foresubText = curNo + no + " " + curName + name;
            }

            let relationId = response.data.relation.id;
            this.rows[this.rowIndex].assistantAccountId = relationId;

            if (!this.rows[this.rowIndex].subject.balance.assist[relationId]) {
                this.$set(this.rows[this.rowIndex].subject.balance.assist, relationId, response.data.balance.endbalance);
            }
            if (!this.rows[this.rowIndex].subject.balance.assist.endnumber) {
                this.rows[this.rowIndex].subject.balance.assist.endnumber = {};
            }
            if (!this.rows[this.rowIndex].subject.balance.assist.endnumber[relationId]) this.$set(this.rows[this.rowIndex].subject.balance.assist.endnumber, relationId, response.data.balance.endnumber);

            // this.rows[this.rowIndex].endbalance = response.data.balance.endbalance;
            // this.rows[this.rowIndex].endnumber = response.data.balance.endnumber;
            if (!noCalc) {
                // 更换辅助核算后，除去当前行的金额计算，并对新选择的辅助核算进行计算
                if (this.rows[this.rowIndex].subject.direction == 1) {
                    if (this.jfTemp != 0) {  // 有借方金额
                        // 新选择的辅助核算进行计算
                        this.rows[this.rowIndex].subject.balance.assist[relationId] = +this.rows[this.rowIndex].subject.balance.assist[relationId] + +this.rows[this.rowIndex].jfmoney;
                        // 库存数量重新计算
                        if (this.rows[this.rowIndex].measuringUnit !== null) this.rows[this.rowIndex].subject.balance.assist.endnumber[relationId] = +this.rows[this.rowIndex].subject.balance.assist.endnumber[relationId] + +this.rows[this.rowIndex].number;

                        if (this.tmpAss != null) {
                            this.rows[this.rowIndex].subject.balance.assist[this.tmpAss] = +this.rows[this.rowIndex].subject.balance.assist[this.tmpAss] - +this.rows[this.rowIndex].jfmoney;  // 旧辅助核算除去计算
                            if (this.rows[this.rowIndex].measuringUnit !== null) this.rows[this.rowIndex].subject.balance.assist.endnumber[this.tmpAss] = +this.rows[this.rowIndex].subject.balance.assist.endnumber[this.tmpAss] - +this.rows[this.rowIndex].number;
                        }
                    } else if (this.dfTemp != 0) {
                        this.rows[this.rowIndex].subject.balance.assist[relationId] = +this.rows[this.rowIndex].subject.balance.assist[relationId] - +this.rows[this.rowIndex].dfmoney;
                        // 库存数量重新计算
                        if (this.rows[this.rowIndex].measuringUnit !== null) this.rows[this.rowIndex].subject.balance.assist.endnumber[relationId] = +this.rows[this.rowIndex].subject.balance.assist.endnumber[relationId] - +this.rows[this.rowIndex].number;

                        if (this.tmpAss != null) {
                            this.rows[this.rowIndex].subject.balance.assist[this.tmpAss] = +this.rows[this.rowIndex].subject.balance.assist[this.tmpAss] + +this.rows[this.rowIndex].dfmoney;
                            if (this.rows[this.rowIndex].measuringUnit !== null) this.rows[this.rowIndex].subject.balance.assist.endnumber[this.tmpAss] = +this.rows[this.rowIndex].subject.balance.assist.endnumber[this.tmpAss] + +this.rows[this.rowIndex].number;
                        }
                    }
                } else {
                    if (this.jfTemp != 0) {  // 有借方金额
                        this.rows[this.rowIndex].subject.balance.assist[relationId] = +this.rows[this.rowIndex].subject.balance.assist[relationId] - +this.rows[this.rowIndex].jfmoney;  // 新选择的辅助核算进行计算
                        // 库存数量重新计算
                        if (this.rows[this.rowIndex].measuringUnit !== null) this.rows[this.rowIndex].subject.balance.assist.endnumber[relationId] = +this.rows[this.rowIndex].subject.balance.assist.endnumber[relationId] - +this.rows[this.rowIndex].number;

                        if (this.tmpAss != null) {
                            this.rows[this.rowIndex].subject.balance.assist[this.tmpAss] = +this.rows[this.rowIndex].subject.balance.assist[this.tmpAss] + +this.rows[this.rowIndex].jfmoney;  // 旧辅助核算除去计算
                            if (this.rows[this.rowIndex].measuringUnit !== null) this.rows[this.rowIndex].subject.balance.assist.endnumber[this.tmpAss] = +this.rows[this.rowIndex].subject.balance.assist.endnumber[this.tmpAss] + +this.rows[this.rowIndex].number;
                        }
                    } else if (this.dfTemp != 0) {
                        this.rows[this.rowIndex].subject.balance.assist[relationId] = +this.rows[this.rowIndex].subject.balance.assist[relationId] + +this.rows[this.rowIndex].dfmoney;
                        if (this.rows[this.rowIndex].measuringUnit !== null) this.rows[this.rowIndex].subject.balance.assist.endnumber[relationId] = +this.rows[this.rowIndex].subject.balance.assist.endnumber[relationId] + +this.rows[this.rowIndex].number;

                        if (this.tmpAss != null) {
                            this.rows[this.rowIndex].subject.balance.assist[this.tmpAss] = +this.rows[this.rowIndex].subject.balance.assist[this.tmpAss] - +this.rows[this.rowIndex].dfmoney;
                            if (this.rows[this.rowIndex].measuringUnit !== null) this.rows[this.rowIndex].subject.balance.assist.endnumber[this.tmpAss] = +this.rows[this.rowIndex].subject.balance.assist.endnumber[this.tmpAss] - +this.rows[this.rowIndex].number;
                        }
                    }
                }
            }
            this.tmpAss = relationId;
            this.tmpOld = this.rows[this.rowIndex].subject;
            this.rows[this.rowIndex].unitPrice = response.data.balance.unitPrice;
            // this.subjectList[this.findSubject(this.rows[this.rowIndex].subject.id)] = this.rows[this.rowIndex].subject;
        } else {
            this.showAssist = false;
            this.rows[this.rowIndex].assistantAccountId = null;
            let curNo = this.rows[this.rowIndex].subject.no,
                curName = this.rows[this.rowIndex].subject.longText;
            this.rows[this.rowIndex].foresubText = curNo + " " + curName;
            if (!noChangeDom) {
                this.showForeignModal();
            }
        }
    }

    // 点击数量外币
    showForeignModal() {
        let parent = (<any>this.$parent);
        if (!parent.isTp && !parent.notEdit) {
            if (this.rows[this.rowIndex].measuringUnit == null && this.rows[this.rowIndex].currSymbol != null) {
                this.showSymbol = true;
                this.moveModal("symModal");
                this.$nextTick(() => {
                    setTimeout(() => {
                    const input: HTMLInputElement = <HTMLInputElement>this.$el.querySelector(".foreignModal input[name='foreignEdit']");
                    input.focus();
                    }, 50);
                });
            } else if (this.rows[this.rowIndex].measuringUnit != null && this.rows[this.rowIndex].currSymbol == null) {
                this.showNum = true;
                this.moveModal("numModal");
                this.$nextTick(() => {
                    setTimeout(() => {
                    const input: HTMLInputElement = <HTMLInputElement>this.$el.querySelector(".foreignModal input[name='foreignEdit']");
                    input.focus();
                    }, 50);
                });
            } else if (this.rows[this.rowIndex].measuringUnit != null && this.rows[this.rowIndex].currSymbol != null) {
                this.showSymNum = true;
                this.moveModal("symNumModal");
                this.$nextTick(() => {
                    setTimeout(() => {
                    const input: HTMLInputElement = <HTMLInputElement>this.$el.querySelector(".foreignModal input[name='foreignEdit']");
                    input.focus();
                    }, 50);
                });
            } else {
                this.showJf = true
            }
        } else {
            this.showJf = true
        }
    }

    /*
        处理数量/金额
    */
    // 保存缓存变量, 取消时使用
    focusEdit(e: any) {
        this.selectInner(e);
    }


    // 外币金额
    cancelSymbol() {
        this.showSymbol = false;
        this.rows[this.rowIndex].org = this.orgTemp;
        this.rows[this.rowIndex].exchangeRate = this.exchangeRateTemp;
    }
    confirmSymbol() {
        this.rows[this.rowIndex].jfmoney = +this.rows[this.rowIndex].org * +this.rows[this.rowIndex].exchangeRate;
        this.showSymbol = false;
        this.showJf = true;
        this.rows[this.rowIndex].subject.exchangeRate = +this.rows[this.rowIndex].exchangeRate;
        this.jfChange(this.rows[this.rowIndex].jfmoney)
    }

    // 数量金额
    cancelUnit() {
        this.showNum = false;
        this.rows[this.rowIndex].number = this.numberTemp;
        this.rows[this.rowIndex].unitPrice = this.unitPriceTemp;
    }
    confirmUnit() {
        this.showNum = false;
        // this.jfTemp = 0;
        // this.dfTemp = 0;
        if (this.rows[this.rowIndex].dfmoney == "") {
            this.rows[this.rowIndex].jfmoney = "";
            if (this.jfTemp === "") this.jfTemp = "";
            else this.jfTemp = 0;
            this.fitMoney("jfmoney");
            // this.$nextTick(() => {
            this.rows[this.rowIndex].jfmoney = (+this.rows[this.rowIndex].number * +this.rows[this.rowIndex].unitPrice).toFixed(2);
            this.showJf = true;
            // this.jfTemp = 0;
            this.jfChange(this.rows[this.rowIndex].jfmoney, false, true);
            // })
        } else {
            if (this.dfTemp === "") this.dfTemp = "";
            else this.dfTemp = 0;
            this.rows[this.rowIndex].dfmoney = "";
            this.fitMoney("dfmoney");
            // this.$nextTick(() => {
            this.rows[this.rowIndex].dfmoney = (+this.rows[this.rowIndex].number * +this.rows[this.rowIndex].unitPrice).toFixed(2);
            this.showDf = true;
            this.dfChange(this.rows[this.rowIndex].dfmoney, false, true);
            // })
        }
    }

    // 数量金额自动调整单价和外币
    changeNumber(val: any) {
        //数量外币列数中有 0  则不自动计算
        if (this.rows[this.rowIndex].number != 0 && this.rows[this.rowIndex].org != 0)
            this.rows[this.rowIndex].org = (+val * +this.rows[this.rowIndex].unitPrice).toFixed(2);
    }
    changePrice(val: any) {
        if (this.rows[this.rowIndex].number != 0 && this.rows[this.rowIndex].org != 0)
            this.rows[this.rowIndex].org = (+val * +this.rows[this.rowIndex].number).toFixed(5);
    }

    fmtPrice() {
        // 单价结为4位小树
        this.rows[this.rowIndex].unitPrice = +((+this.rows[this.rowIndex].unitPrice).toFixed(4));
    }

    changeOrg(val: any) {
        if (this.rows[this.rowIndex].number != 0 && this.rows[this.rowIndex].org != 0)
            this.rows[this.rowIndex].unitPrice = (+val / +this.rows[this.rowIndex].number).toFixed(4)
    }

    // 数量金额
    cancelSymbolUnit() {
        this.showSymNum = false;
        this.rows[this.rowIndex].org = this.orgTemp;
        this.rows[this.rowIndex].exchangeRate = this.exchangeRateTemp;
        this.rows[this.rowIndex].number = this.numberTemp;
        this.rows[this.rowIndex].unitPrice = this.unitPriceTemp;
    }
    confirmSymbolUnit() {
        this.rows[this.rowIndex].subject.exchangeRate = +this.rows[this.rowIndex].exchangeRate;
        this.showSymNum = false;
        if (this.rows[this.rowIndex].dfmoney == "") {
            this.rows[this.rowIndex].jfmoney = "";
            if (this.jfTemp === "") this.jfTemp = "";
            else this.jfTemp = 0;
            this.fitMoney("jfmoney");
            this.rows[this.rowIndex].jfmoney = +this.rows[this.rowIndex].org * +this.rows[this.rowIndex].exchangeRate;
            this.showJf = true;
            this.jfChange(this.rows[this.rowIndex].jfmoney, false, true);
        } else {
            if (this.dfTemp === "") this.dfTemp = "";
            else this.dfTemp = 0;
            this.rows[this.rowIndex].dfmoney = "";
            this.fitMoney("dfmoney");
            this.rows[this.rowIndex].dfmoney = +this.rows[this.rowIndex].org * +this.rows[this.rowIndex].exchangeRate;
            this.showDf = true;
            this.dfChange(this.rows[this.rowIndex].dfmoney, false, true);
        }
    }


    /*
        借方贷方金额输入框处理
        */
    clickJf(e: any) {
        if (!(<any>this.$parent).notEdit) this.showJf = true;
    }
    clickDf(e: any) {
        if (!(<any>this.$parent).notEdit) this.showDf = true
    }
    fitMoney(attr: any) {
        if (this.rows[this.rowIndex]) {
            let _this: any = this;
            _this[attr] = new Array(11);
            // let money  = this.rows[this.rowIndex][attr];
            if (this.rows[this.rowIndex][attr] != "" || this.rows[this.rowIndex][attr] != 0) {
                this.rows[this.rowIndex][attr] = Number(this.rows[this.rowIndex][attr]).toFixed(2)
                if (Number(this.rows[this.rowIndex][attr]) > 999999999.99) {
                    this.rows[this.rowIndex][attr] = "999999999.99"
                }
                let arr = this.rows[this.rowIndex][attr].split("").reverse(), j, hasDot = arr.indexOf(".");

                const isNega = arr.indexOf("-");
                if (isNega != -1) {
                    // this.arrayRemove(arr, "-");
                    arr.splice(isNega, 1);
                }
                if (hasDot == -1) {
                    j = 8;
                } else {
                    j = 10;
                    // this.arrayRemove(arr, ".");
                    arr.splice(hasDot, 1);
                }
                for (let i = 0; i < arr.length; i++) {
                    _this[attr][j] = arr[i];
                    j--;
                }
            } else {
                _this[attr] = new Array(11)
            }
        }
    }

    jfBlur(e?: any, notEmit?: any, isPack?: boolean) {
        this.showJf = false;
        if (this.rows[this.rowIndex].jfmoney === undefined) this.rows[this.rowIndex].jfmoney = 0;
        this.rows[this.rowIndex].jfmoney = (this.rows[this.rowIndex].jfmoney.toString()).replaceAll(",", "").replaceAll("，", "");
        try {
            if (this.rows[this.rowIndex] && this.rows[this.rowIndex].jfmoney !== "") this.rows[this.rowIndex].jfmoney = eval(this.rows[this.rowIndex].jfmoney);
        } catch(e) {
            console.error(e);
            this.$message("输入格式有误");
            if (this.rows[this.rowIndex] && this.rows[this.rowIndex].jfmoney !== "") this.rows[this.rowIndex].jfmoney = 0;
        }
        let money = this.rows[this.rowIndex] ? this.rows[this.rowIndex].jfmoney : 0;
        this.jfTemp = money;
        this.fitMoney("jfmoney");
        this.$emit("addJf", money)
    }
    dfBlur(e?: any, notEmit?: any, isPack?: boolean) {
        this.showDf = false;
        if (this.rows[this.rowIndex].dfmoney === undefined) this.rows[this.rowIndex].dfmoney = 0;
        this.rows[this.rowIndex].dfmoney = (this.rows[this.rowIndex].dfmoney.toString()).replaceAll(",", "").replaceAll("，", "");
        try {
            if (this.rows[this.rowIndex] && this.rows[this.rowIndex].dfmoney !== "") this.rows[this.rowIndex].dfmoney = eval(this.rows[this.rowIndex].dfmoney);
        } catch(e) {
            console.error(e);
            this.$message("输入格式有误");
            if (this.rows[this.rowIndex] && this.rows[this.rowIndex].dfmoney !== "") this.rows[this.rowIndex].dfmoney = 0;
        }
        let money = this.rows[this.rowIndex] ? this.rows[this.rowIndex].dfmoney : 0;
        this.dfTemp = money;

        this.fitMoney("dfmoney");
        this.$emit("addDf", money)
    }

    // 保存备份
    focusSummary(e: any) {
        this.focusEdit(e);
        if (this.rowIndex != 0) {
            let hasJf = this.rows[this.rowIndex - 1].jfmoney != 0 && this.rows[this.rowIndex - 1].jfmoney != "",
                hasDf = this.rows[this.rowIndex - 1].dfmoney != 0 && this.rows[this.rowIndex - 1].dfmoney != "",
                noSummary = this.rows[this.rowIndex].summary == "",
                noJf = this.rows[this.rowIndex].jfmoney == 0 || this.rows[this.rowIndex].jfmoney == "",
                noDf = this.rows[this.rowIndex].dfmoney == 0 || this.rows[this.rowIndex].dfmoney == "";

            if (noSummary) this.rows[this.rowIndex].summary = this.rows[this.rowIndex - 1].summary;
            if (hasJf || hasDf) {
                if (hasJf) {
                    if (noJf && noDf) {
                        this.rows[this.rowIndex].dfmoney = +(<any>this.$parent).loanTotal - +(<any>this.$parent).creditTotal - +this.rows[this.rowIndex].jfmoney;
                        this.dfTemp = this.rows[this.rowIndex].dfmoney;
                        this.jfTemp = 0;
                        this.dfChange(this.rows[this.rowIndex].dfmoney);
                        this.fitMoney("dfmoney");
                    }
                } else {
                    if (noJf && noDf) {
                        this.rows[this.rowIndex].jfmoney = +(<any>this.$parent).creditTotal - +(<any>this.$parent).loanTotal - +this.rows[this.rowIndex].dfmoney;
                        this.jfTemp = this.rows[this.rowIndex].dfmoney;
                        this.dfTemp = 0;
                        this.jfChange(this.rows[this.rowIndex].jfmoney);
                        this.fitMoney("jfmoney");
                    }
                }
            }

            if (this.rowIndex % 5 === 0) {
                this.$emit("backup");
            }
        }
    }

    // 点击新增科目
    emitSub() {
        this.$emit("addSub", this.rowIndex)
    }

    // 新增辅助核算相关
    emitAss(ass: string, aIndex: number) {
        let getNo: any = 0;
        let list: any = this.rows[this.rowIndex].assistList[ass];
        if (list.length != 0) getNo = Number(list[list.length - 1].no) + 1;
        else getNo = 1;
        if (getNo < 10) getNo = "000" + getNo
        else if (getNo < 100) getNo = "00" + getNo
        else if (getNo < 1000) getNo = "0" + getNo
        this.$emit("addAssist", ass, getNo, this.rowIndex, aIndex);
    }

    showAssSelect() {
        this.forbidScroll();
        this.getAssistList(this.rows[this.rowIndex].subject.dimAccountTypes[0], () => {
            this.showAssist = true;
            this.$nextTick(() => {
                let assModalInput: any = document.querySelector("#assModal input");
                assModalInput.focus();
            })
        });
    }

    removeDot(e: any) {
        // e.preventDefault();
        // console.log(e, e.target.value, "org");
        // const value = e.target.value.replaceAll(",", "").replaceAll("，", "");
        // e.target.value = value;
        // this.rows[this.rowIndex].jfmoney = value;
        // this.jfTemp = value;
        // console.log(e.target.value, value)
    }

    // 科目辅助明细账
    // 获取表格数据
    @Prop()
    dateTime!: Date;

    assistBalance = {
        visible: false,
        numVisible: false,
        data: <any>[],
        yearMonth: "",
        period: "",
        valueList: <any>{}
    }
    
	async fetchAssist() {
        const period = this.$utils.simpleDateFormat(this.dateTime, "m");
        this.assistBalance.yearMonth = `${period.substring(0, 4)}年${period.substring(4)}月`;
        this.assistBalance.period = period;
        let obj = {
            accountBookId: this.$store.state.accountBook.id,
            subjectId: <number | null>null,
            startPeriod: period,
            endPeriod: period,
            relation: null,
            assistingAccountId: null,
            isHideTotal: 0
        };
        
        const subject = this.rows[this.rowIndex].subject;
        const assist = this.rows[this.rowIndex].assist;
        if (subject) {
            obj.subjectId = <number>subject.id;
        }
        obj.relation = this.relation;
        let res = await Vue.axios.post(`details/find`, obj);
        if (res) this.assistBalance.data = res.data.subsidiarys;
        // this.rows
        // if (!this.assistBalance.valueList) this.assistBalance.valueList = {};
        subject.dimAccountTypes.forEach((type: string) => {
            if (assist[type]) this.assistBalance.valueList[type] = assist[type];
            else this.assistBalance.valueList = null;
        });
		
	}
}
